import SectionHeader from "./SectionHeader";

const steps = [
  {
    icon: "ri-search-line",
    title: "找到想追的漫画",
    desc: "在热门连载、完结精选里浏览，或用搜索框直接输入漫画名、分类与标签，快速定位目标作品。",
  },
  {
    icon: "ri-bookmark-line",
    title: "收藏作品",
    desc: "点一下收藏，作品就进入你的追更清单，后续更新与进度变化都会同步记录下来。",
  },
  {
    icon: "ri-refresh-line",
    title: "同步最新话",
    desc: "最新话更新后，更新状态会自动刷新，连载进度条同步推进，续看跳回上次读到的地方。",
  },
  {
    icon: "ri-notification-3-line",
    title: "开启更新提醒",
    desc: "开启提醒后，新章节上线第一时间推送，热门连载永不遗漏，追更稳稳不迷路。",
  },
];

export default function HowItWorks() {
  return (
    <section id="guide" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          tag="三步上手"
          title="追更指南，四步看懂进度"
          desc="无论你是刚入坑的新读者，还是追了几百话的老漫迷，这套流程都能帮你把进度安排得明明白白。"
          align="center"
        />

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, i) => (
            <div
              key={step.title}
              className="relative overflow-hidden rounded-lg bg-background-50 p-6 ring-1 ring-background-200"
            >
              <span className="absolute right-4 top-3 font-heading text-4xl text-background-200">
                {i + 1}
              </span>
              <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <h3 className="text-base font-semibold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}